import React, { useState, useEffect, useCallback } from 'react';
import Axios from 'axios';
import { ApiConstant } from '../../../../constants';
import {
  Modal,
  Card,
  Typography,
  Button,
  Tag,
  Select,
  Spin,
  notification,
  Form
} from 'antd';
import PropTypes from 'prop-types';
import './InStackDemandOtherSelectorModal.css';
import { withStyles } from '@material-ui/core/styles';
import roundCheck from '../../../../assets/img/round-check_circle-24px.svg';
import _ from 'lodash';
import InStackDemandSelectorActions from '../InStackDemandSelector/InStackDemandSelector.actions';
import { connect } from 'react-redux';
import DeleteFilled from '@material-ui/icons/DeleteRounded';
import getEnv from '../../../../../services/util/getEnv';

const { Title } = Typography;

const useStyles = (theme) => ({
  roundCheck: {
    width: '18px',
    height: '18px',
    background:
      'transparent url(' +
      roundCheck +
      ') 0% 0% no-repeat padding-box !important',
    opacity: '1'
  },

  completedButton: {
    border: 'none',
    color: '#66CC80',
    width: '84px',
    height: '36px',
    padding: '0px',
    pointerEvent: 'none',
    letterSpacing: '0.56px',
    textDecoration: 'none',
    outline: 'none',
    fontSize: '0.9em'
  },

  buttonItemSpacing: {
    marginLeft: '10px',
    textAlign: 'right'
  },

  medianMCQTime: {
    textAlign: 'left',
    font: 'Regular 12px/16px',
    letterSpacing: '0px',
    color: '#AAAAAA',
    opacity: 1
  }
});

const initialState = {
  selectedAdditionalSkills: [],
  languagesList: [],
  selectedLanguage: []
};

function InStackDemandOtherSelectorModal (props) {
  const { activeItem, onClose, dispatch, user_demand_stack_skills } = props;
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState(initialState);
  const [searchingSkills, setSearchingSkills] = useState(false);
  const [skillList, setSkillList] = useState([]);
  const [errors, setErrors] = useState({
    selectedLanguage: {},
    additionalSkills: {}
  });
  const [already_saved_other_stack_demand, setAlreadySavedOtherStackDemand] = useState(false);

  const languageOnChange = (skill_id) => {
    const selectedLanguage = [];
    state.languagesList.forEach((language) => {
      // language.checked = false;
      if (language.skill_id === skill_id) {
        language.checked = !language.checked;
      }
      if (language.checked) {
        selectedLanguage.push(language);
      }
    });
    setState({ ...state, languagesList: state.languagesList, selectedLanguage });
    setErrors({ ...errors, selectedLanguage: {} });
  };

  const EndPoint = `${ApiConstant.BASE_URL}common-user/`;

  const fetchSkills = useCallback(async (search_term) => {
    try {
      const results = await Axios.post(EndPoint, { action: 'GET_MCQ_SKILLS', filter: search_term });
      setSkillList(results.data.result);
    } catch (error) {
      setSkillList([]);
    }
    setSearchingSkills(false);
  }, []);

  const fetchSkillsDebounce = useCallback(_.debounce(fetchSkills, 1000), []);

  const handleSelectSearch = search_term => {
    setSearchingSkills(true);
    fetchSkillsDebounce.cancel();
    fetchSkillsDebounce(search_term);
  };

  const handleSelectChange = (selectedAdditionalSkills) => {
    // if (selectedAdditionalSkills.length < 3) {
    setState({ ...state, selectedAdditionalSkills });
    setErrors({ ...errors, additionalSkills: {} });
    // }
  };

  const fetchLanguagesList = async () => {
    let languagesList = [];
    try {
      const results = await Axios.post(EndPoint, { action: 'GET_OTHER_STACK_SKILLS' });
      languagesList = results.data.result.map((lang) => ({ ...lang, checked: false }));
    } catch (error) {
    } finally {
      setLoading(false);
    }
    return languagesList;
  };

  const fetchOtherStackDemandDev = async () => {
    let otherStackDemandDev = [];
    try {
      const results = await Axios.post(EndPoint, { action: 'GET_OTHER_STACK_DEMAND_DEV' });
      otherStackDemandDev = results.data.result;
      setAlreadySavedOtherStackDemand(otherStackDemandDev.length > 0);
    } catch (error) {
    } finally {
      setLoading(false);
    }
    return otherStackDemandDev;
  };

  const handleModalConfirm = async (e) => {
    const body = {
      selectedLanguage: getSelectedLanguage().map(lang => lang.skill_id),
      selectedAdditionalSkills: state.selectedAdditionalSkills
    };
    const dontHaveMainLanguageSelected = !body.selectedLanguage || (Array.isArray(body.selectedLanguage) && body.selectedLanguage.length < 1);
    const dontHaveAdditionalSkillsSelected = !body.selectedAdditionalSkills || (Array.isArray(body.selectedAdditionalSkills) && body.selectedAdditionalSkills.length < 1);
    const validationErrors = { selectedLanguage: {}, additionalSkills: {} };
    if (dontHaveMainLanguageSelected) {
      validationErrors.selectedLanguage = {
        validateStatus: 'error',
        help: 'You must select at least one main language'
      };
    }
    if (dontHaveAdditionalSkillsSelected) {
      validationErrors.additionalSkills = {
        validateStatus: 'error',
        help: 'You must select at least an additional skill'
      };
    }
    if (dontHaveMainLanguageSelected || dontHaveAdditionalSkillsSelected) {
      setErrors({
        ...errors,
        selectedLanguage: validationErrors.selectedLanguage,
        additionalSkills: validationErrors.additionalSkills
      });
      return;
    }
    try {
      await Axios.post(EndPoint, { action: 'SAVE_OTHER_STACK_DEMAND_DEV', ...body });
      notification.success({ message: 'Selected skills saved successfully.' });
      closeModal(e, 'submit');
    } catch (error) {
      const { response } = error;
      notification.error({ message: `Failed to save selected skills.\n\n${response.data.errorMessage}\n\nPlease try again.` });
    }
  };

  const getSelectedLanguage = () => {
    return (state.selectedLanguage !== null && typeof state.selectedLanguage !== 'undefined' ? state.selectedLanguage : []);
  };

  const deleteOtherStack = async (e) => {
    try {
      await Axios.post(EndPoint, { action: 'DELETE_OTHER_STACK_DEMAND_DEV' });
      closeModal(e, 'delete');
    } catch (error) {
      const { response } = error;
      notification.error({ message: `Failed to delete skills.\n\n${response.data.errorMessage}\n\nPlease try again.` });
    }
  };

  const closeModal = async (e, type) => {
    activeItem && activeItem.close(e);
    let otherStackSkillsIds = [
      ...state.selectedAdditionalSkills.map(skill_id => parseInt(skill_id)),
      ...getSelectedLanguage().map(lang => lang.skill_id)
    ];
    let skillsIds = Object.assign([], user_demand_stack_skills.skillsIds);
    let stackDemandIds = Object.assign([], user_demand_stack_skills.stackDemandIds);
    let otherStackDemandId = parseInt(getEnv("REACT_APP_OTHER_STACK_DEMAND_ID"));
    if (type === 'submit') {
      if (otherStackSkillsIds.length > 0) {
        skillsIds.push(...otherStackSkillsIds);
        skillsIds = _.uniq(skillsIds);
        stackDemandIds.push(otherStackDemandId);
        stackDemandIds = _.uniq(stackDemandIds);
      }
    }
    if (type === 'delete') {
      let ignoreSkillsId = [];
      const { data } = await Axios.post(`${ApiConstant.BASE_URL}common-user/`, { action: 'GET_STACK_DEMAND_DEV' });
      if (data && data.success && Array.isArray(data.result)) {
        const [,, stackDemandDev] = data.result;
        if (stackDemandDev && Array.isArray(stackDemandDev)) {
          ignoreSkillsId = stackDemandDev.filter(s => +s.stack_demand_id !== +otherStackDemandId).map(s => s.skill_id);
        }
      }
      _.remove(skillsIds, (el) => otherStackSkillsIds.indexOf(el) > -1 && !ignoreSkillsId.includes(el));
      _.remove(stackDemandIds, (el) => el === otherStackDemandId);
      otherStackSkillsIds = [];
      otherStackDemandId = null;
    }
    if (['submit', 'delete'].indexOf(type) > -1) {
      dispatch({ type: InStackDemandSelectorActions.SET_SELECTED_SKILLS, payload: { skillsIds, stackDemandIds, otherStackSkillsIds, otherStackDemandId } });
    }
    setSearchingSkills(false);
    setState(initialState);
    setErrors({ selectedLanguage: {}, additionalSkills: {} });
    onClose && onClose(e, { skillsIds, visible: true });
  };

  const onShow = async () => {
    // Get OTHER STACK DEMAND main languages
    const languagesList = await fetchLanguagesList();
    // Get Developer OTHER STACK DEMAND selected skills
    const otherStackDemandDev = await fetchOtherStackDemandDev();
    const selectedOtherSkills = [];
    // Find if there is a main language selected
    otherStackDemandDev.forEach(selectedSkill => {
      let isMainLanguage = false;
      languagesList.forEach(language => {
        language.checked = selectedSkill.skill_id === language.skill_id;
        if (language.checked) isMainLanguage = true;
      });
      if (!isMainLanguage) {
        selectedOtherSkills.push(Object.assign({}, selectedSkill));
      }
    });
    // Set checked for the main languages
    const selectedLanguage = [];
    languagesList.forEach(language => {
      language.checked = otherStackDemandDev.some(selectedSkill => selectedSkill.skill_id === language.skill_id);
      if (language.checked) selectedLanguage.push(language);
    });
    setSkillList(selectedOtherSkills);
    setState({
      ...state,
      languagesList,
      selectedAdditionalSkills: selectedOtherSkills.map(skill => skill.skill_id.toString()),
      selectedLanguage
    });
  };

  /* Modal onShow */
  useEffect(() => {
    setAlreadySavedOtherStackDemand(false);
    if (!activeItem) return;
    onShow();
  }, [activeItem]);

  return (
    <Modal
      visible={!!activeItem}
      onCancel={closeModal}
      footer={null}
      className="turing-ui-v2-instack-demand-other-modal"
      bodyStyle={{ padding: 0, margin: 0 }}
      destroyOnClose
      centered
    >
      <Spin spinning={loading}>
        <div className="turing-ui-v2-instack-demand-other-modal-container">
          <Card>
            <Title level={4}>What other tech stack do you want to be vetted for?</Title>
            <Typography.Paragraph>
              Warning: You have the highest chance of getting matched if you choose one of our in-demand tech stacks. If none of them fit you, feel free to select your custom tech stack below.
            </Typography.Paragraph>
            <div className="select-main-language">
              <h5 className="ant-typography">
                Select your main language
              </h5>
            </div>
            <div className="InStackDemandOtherSelector">
              <Form.Item
                validateStatus={errors.selectedLanguage.validateStatus}
                help={errors.selectedLanguage.help}>
                {
                  state.languagesList.map((language) => {
                    return (
                      <Tag.CheckableTag
                        key={language.skill_id}
                        className="InStackDemandItem"
                        checked={!!language.checked}
                        onChange={(e) => languageOnChange(language.skill_id)}
                        onClick={e => e.stopPropagation()}>
                        <span>{ language.skill_name }</span>
                      </Tag.CheckableTag>
                    );
                  })
                }
              </Form.Item>
            </div>
            <div className="select-skills">
              <h5 className="ant-typography">
                Add any other skills you want to be vetted for
              </h5>
            </div>
            <div className="additional-skills">
              <Form.Item
                validateStatus={errors.additionalSkills.validateStatus}
                help={errors.additionalSkills.help}>
                <Select
                  size="large"
                  mode='multiple'
                  filterOption={false}
                  loading={searchingSkills}
                  placeholder='Search for skill(s)'
                  value={state.selectedAdditionalSkills}
                  onChange={ handleSelectChange }
                  onSearch={ handleSelectSearch }
                  style={{ width: '100%' }}
                  dropdownRender={ menu => (
                    <Spin spinning={searchingSkills}>
                      { menu }
                    </Spin>
                  )}>
                  {
                    skillList.map(s =>
                      <Select.Option key={s.skill_id}>{s.skill_name}</Select.Option>
                    )
                  }
                </Select>
              </Form.Item>
            </div>
            <div className="after-commiting-warning">
              After confirming, please add your years of experience and competency for each skill
            </div>
            <div className="modal-actions">
              {already_saved_other_stack_demand &&
                <Button
                  disabled={false}
                  type="danger"
                  onClick={deleteOtherStack}
                  style={{ color: '#ff4d4f' }}
                  ghost
                >
                  <DeleteFilled size="30px" />Delete
                </Button>
              }
              <div style={{ float: 'right' }}>
                <Button
                  disabled={false}
                  type="secondary"
                  onClick={closeModal}
                >
                  Close
                </Button>
                <Button
                  disabled={false}
                  type="primary"
                  onClick={ handleModalConfirm }
                >
                  Confirm
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </Spin>
    </Modal>
  );
}

InStackDemandOtherSelectorModal.propTypes = {
  activeItem: PropTypes.object,
  name: PropTypes.string,
  disabledStart: PropTypes.any,
  classes: PropTypes.object,
  onClose: PropTypes.any,
  dispatch: PropTypes.func,
  user_demand_stack_skills: PropTypes.object
};

const mapStateToProps = appState => ({
  user_demand_stack_skills: appState.user_demand_stack_skills
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(InStackDemandOtherSelectorModal));
